(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.location.hash) return;

    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation && navigation.type === 'back_forward') return;

    const showHero = () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if (document.readyState === 'complete') {
      showHero();
    } else {
      window.addEventListener('load', showHero, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-product"]) return;
  try {
    
  (()=>{document.querySelectorAll('[data-product-page]').forEach((page)=>{page.querySelectorAll('.mc-product-variant input').forEach((input)=>input.addEventListener('change',(event)=>{page.querySelector('[data-product-price]').textContent=event.currentTarget.dataset.price}));page.querySelectorAll('[data-counted-input]').forEach((input)=>{const count=input.closest('.mc-product-field').querySelector('[data-character-count]');input.addEventListener('input',()=>{count.textContent=input.value.length})});page.querySelectorAll('[data-delivery-checker]').forEach((checker)=>{const input=checker.querySelector('[data-postcode]');const result=checker.querySelector('[data-delivery-result]');checker.querySelector('[data-check-delivery]').addEventListener('click',async()=>{const postcode=input.value.trim().replace(/\s+/g,'');if(!postcode){result.textContent=page.dataset.emptyPostcode;return}result.textContent=page.dataset.checkingPostcode;try{const response=await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(postcode)}`);const data=await response.json();if(!response.ok||!data.result)throw new Error();const r=(value)=>value*Math.PI/180;const a=Math.sin((r(data.result.latitude)-r(51.5258))/2)**2+Math.cos(r(51.5258))*Math.cos(r(data.result.latitude))*Math.sin((r(data.result.longitude)-r(-.0877))/2)**2;const miles=3958.8*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));const template=miles<=10?page.dataset.localDelivery:page.dataset.nationalDelivery;result.textContent=template.replace('[miles]',miles.toFixed(1))}catch(_){result.textContent=page.dataset.invalidPostcode}})})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mincha-welcome-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-welcome-offer]');
    if (!root) return;
    const dialog = root.querySelector('[data-welcome-dialog]');
    const key = 'mincha-welcome-offer-seen';
    const open = () => { if (!dialog.open) dialog.showModal(); };
    const close = () => { if (dialog.open) dialog.close(); try { sessionStorage.setItem(key, '1'); } catch (_) {} };
    root.querySelector('[data-welcome-open]').addEventListener('click', open);
    root.querySelectorAll('[data-welcome-close]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    root.querySelector('[data-copy-code]')?.addEventListener('click', async (event) => {
      const code = root.querySelector('.mc-welcome__code strong')?.textContent?.trim();
      if (!code) return;
      try { await navigator.clipboard.writeText(code); event.currentTarget.textContent = 'Copied'; } catch (_) { event.currentTarget.textContent = code; }
    });
    try { if (!sessionStorage.getItem(key)) window.setTimeout(open, 1500); } catch (_) { window.setTimeout(open, 1500); }
  })();

  } catch(e) { console.error(e); }
})();
})();
